"use strict"

const el = wp.element.createElement;
const withState = wp.compose.withState;
const withSelect = wp.data.withSelect;
const withDispatch = wp.data.withDispatch;

wp.hooks.addFilter(
    'editor.PostFeaturedImage',
    'extend-block/disable-featured-image-control',
    wrapPostFeaturedImage
);

function wrapPostFeaturedImage( OriginalComponent ) {

    return function( props ) {
        return (
            el(
                wp.element.Fragment,
                {},
                el(
                    OriginalComponent,
                    props
                ),
                el(
                    composedCheckBox
                )
            )
        );
    }
}



class CheckBoxCustom extends React.Component {

    render() {
        const {
            meta,
            updateDisableFeaturedImage,
        } = this.props;

console.log(meta);

        return (
            el(
                wp.components.CheckboxControl,
                {
                    label: "Hide featured image",
                    help: "If checked, the featured image will not show up on single post page.",
                    checked: meta.editedMeta.disable_featured_image,
                    onChange:
                        ( value ) => {
                            this.setState( { isChecked: value } );
                            updateDisableFeaturedImage( value, meta );
                        }
                }
            )
        )
    }
}

const composedCheckBox = wp.compose.compose( [
    withState( ( value ) => { isChecked: value } ),
    withSelect( ( select ) => {
        const currentMeta = select( 'core/editor' ).getCurrentPostAttribute( 'meta' );
		const editedMeta = select( 'core/editor' ).getEditedPostAttribute( 'meta' );
		
        return {
            meta: { currentMeta, editedMeta },
        };
    } ),
    withDispatch( ( dispatch ) => ( {
        updateDisableFeaturedImage( value, meta ) {
            meta = {
                meta,
                disable_featured_image: value,
            };
            dispatch( 'core/editor' ).editPost( { meta } );
        },
    } ) ),
] )( CheckBoxCustom );
